// extracted by mini-css-extract-plugin
export default {"myStats":"lWHoTVs_pTHaRJuoFvFQ","stat":"zUPLWTaaHqH83HzVSwoN"};